<template>
    <qc-container title="商品管理">
        <page-request ref="table" url="/api/mgr/shop/goods/list" :table-header="tableHeader" :expend="expend" :prop="{goodsType:0,orgId:orgId}" :op-width="200">
            <template #op="scope">
<!--
                <b-button @click="doEdit(scope.row)">查看</b-button>
-->
                <b-button v-show="scope.row.enables===0" @click="updateStatus(scope.row.goodsId,1)">上架</b-button>
                <b-button v-show="scope.row.enables===1" @click="updateStatus(scope.row.goodsId,0)">下架</b-button>
            </template>
        </page-request>
    </qc-container>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";

export default {
    props:{
        orgId:{
            type:String,
        }
    },
    name: "store-goods-list",
    components: {PageRequest, TButton, BButton, QcContainer},
    data() {
        return {
            tableHeader: [
                {type: "selection", label: ""},
                {type: "goods", label: "商品",minWidth:300},
                {label: "价格",renderDraw:row=>{
                        let content = "";
                        if(row.storeGoodsType===1 ){
                            content = "租赁价格:￥"+row.marketPrice+"元";
                        }else if(row.storeGoodsType===2){
                            content = "出售价格:￥"+row.salesPrice+"元<br/>"+"租赁价格:￥"+row.marketPrice+"元"
                        }else{
                            content = "出售价格:￥"+row.salesPrice+"元";
                        }
                        return content + (row.isAttribute?"起":"");
                    },width:220},
                {prop: "inventory", label: "库存",width:100,renderDraw:row=>{
                        return row.inventory + (row.marketInventory||0);
                    }},
                {label: "状态",renderDraw:row=>{return row.enables?"在售":"下架";},width: 100},
                {prop: "updateTime", label: "更新时间",width:160},
                {prop: "goodsCreateTime", label: "创建时间",width:160},
            ],
            expend: [
                {label: "商品名称", prop: "name"},
                {label: "商品ID", prop: "codes"},
                {label: "创建时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
            ],
        }
    },
    mixins: [tableBase],
    methods: {
        doEdit(row) {
            this.toRouter("/index/shop/goods/detail",row?{id:row.id,type:this.type}:{})
        },
        updateStatus(id,enables){
            this.msgConfirm("/api/mgr/shop/goods/updateEnables",{goodsId:id,enables:enables,shopId:this.orgId},()=>{
                this.pageReloadData();
            },`您是否要${enables?'上架':'下架'}所选商品?`)
        }
    },
    mounted() {

    }
}
</script>


<style lang="less" scoped>
</style>
